import { formatDate } from 'utils/libs/dateFormats';

const DEFAULT_EXPORT_NAME = 'Exportación de datos';
const EXCEL_SHEET_NAME_MAX_LENGTH = 31;
const EXCEL_INVALID_NAME_CHARACTERS = /[\\/:?*\[\]]/g;
const EXPORT_DATETIME_FORMAT = 'DD/MM/YYYY HH:mm';
const SUPPORTED_EXPORT_CONFIG_VERSIONS = new Set([1, 2]);

export const getExportName = ({ moduleName, datasourceName } = {}) =>
	[moduleName, datasourceName].filter(Boolean).join(' - ') ||
	DEFAULT_EXPORT_NAME;

export const getSafeExportName = name =>
	(name || DEFAULT_EXPORT_NAME)
		.replace(EXCEL_INVALID_NAME_CHARACTERS, '-')
		.trim();

export const getExportSheetName = name =>
	getSafeExportName(name).slice(0, EXCEL_SHEET_NAME_MAX_LENGTH);

export const getVisibleFields = (fields = []) =>
	fields.filter(field => field?.id && field?.name);

const isValidExportColumn = column =>
	typeof column?.header === 'string' &&
	column.header.trim().length > 0 &&
	typeof column?.source === 'string' &&
	column.source.trim().length > 0 &&
	(column.type === undefined || column.type === 'dateTime');

const getConfiguredColumns = exportConfig => {
	if (
		!SUPPORTED_EXPORT_CONFIG_VERSIONS.has(exportConfig?.version) ||
		!Array.isArray(exportConfig.columns) ||
		exportConfig.columns.length === 0 ||
		!exportConfig.columns.every(isValidExportColumn) ||
		new Set(exportConfig.columns.map(column => column.header)).size !==
			exportConfig.columns.length
	)
		return null;

	return exportConfig.columns;
};

const getValueAtPath = (row, source) =>
	source.split('.').reduce((value, key) => value?.[key], row);

const projectConfiguredDatasourceForExport = ({
	datasource,
	columns,
	profile,
}) =>
	datasource.map(row =>
		columns.reduce((exportedRow, column) => {
			const sourceValue = getValueAtPath(row, column.source);
			const value = sourceValue ?? column.default;

			exportedRow[column.header] =
				value === null || value === undefined
					? ''
					: column.type === 'dateTime'
						? formatDate(value, profile, EXPORT_DATETIME_FORMAT)
						: value;

			return exportedRow;
		}, {}),
	);

export const projectDatasourceForExport = ({
	datasource = [],
	fields = [],
	profile,
	exportConfig,
}) => {
	const configuredColumns = getConfiguredColumns(exportConfig);
	if (configuredColumns)
		return projectConfiguredDatasourceForExport({
			datasource,
			columns: configuredColumns,
			profile,
		});

	const visibleFields = getVisibleFields(fields);

	return datasource.map((row, rowIndex) =>
		visibleFields.reduce(
			(exportedRow, field) => ({
				...exportedRow,
				[field.name]:
					field.id === 'index'
						? rowIndex + 1
						: field.dateFormat && row?.[field.id]
							? formatDate(row[field.id], profile, field.dateFormat)
							: row?.[field.id],
			}),
			{},
		),
	);
};
